import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './i18n/LanguageContext';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { BackToTop } from './components/layout/BackToTop';
import { ScrollToTop } from './components/layout/ScrollToTop';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { HowItWorks } from './pages/HowItWorks';
import { Faq } from './pages/Faq';
import { Contact } from './pages/Contact';
export function App() {
  return <LanguageProvider data-id="element-0" data-mp="31bi9hlvy0iew">
      <BrowserRouter data-id="element-1" data-mp="31c1l6kv02akh">
        <ScrollToTop data-id="element-2" data-mp="2wk09b01quluz" />
        <div className="w-full min-h-screen bg-white flex flex-col" data-id="element-3" data-mp="2wjgq7g0cxrfd">
          <Header data-id="element-4" data-mp="2wi5qbra193tj" />
          <main className="flex-1" data-id="element-5" data-mp="28u5vaf5our95">
            <Routes data-id="element-6" data-mp="28t4k8aooa4rf">
              <Route path="/" element={<Home data-id="element-8" data-mp="23vchsmqej08z" />} data-id="element-7" data-mp="28sbbj465l56n" />
              <Route path="/about" element={<About data-id="element-10" data-mp="23utbk3a460as" />} data-id="element-9" data-mp="23w4gi6fape3h" />
              <Route path="/services" element={<Services data-id="element-12" data-mp="3ikh829m9asyz" />} data-id="element-11" data-mp="23ti8y6semyl9" />
              <Route path="/how-it-works" element={<HowItWorks data-id="element-14" data-mp="3ii4su47vuwpm" />} data-id="element-13" data-mp="3ij66mgga9xb1" />
              <Route path="/faq" element={<Faq data-id="element-16" data-mp="3mk85uxa7a9d0" />} data-id="element-15" data-mp="3ml1397n9rmih" />
              <Route path="/contact" element={<Contact data-id="element-18" data-mp="3rcj6618urx63" />} data-id="element-17" data-mp="3mjpyb4i388ps" />
            </Routes>
          </main>
          <Footer data-id="element-19" data-mp="3rd191gq0t9mz" />
          <BackToTop data-id="element-20" data-mp="3relvsk63foaa" />
        </div>
      </BrowserRouter>
    </LanguageProvider>;
}